import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import NotFoundPage from "./v3/pages/basic/404";
import CatalogPage from "./v3/pages/shop/catalog";
import ProductDetailPage from "./v3/pages/shop/product";
import SearchPage from "./v3/pages/shop/search";
import PromoPage from "./v3/pages/shop/promo";
import CartPage from "./v3/pages/shop/cart";
import CheckoutPage from "./v3/pages/shop/checkout";
import OrderTrackingPage from "./v3/pages/shop/track_order";
import BlogPage from "./v3/pages/blog/blog";
import BlogPostPage from "./v3/pages/blog/post";
import AboutUsPage from "./v3/pages/basic/about";
import ContactsPage from "./v3/pages/basic/contacts";
import DeliveryPaymentPage from "./v3/pages/shop/delivery_and_pay";
import UserProfilePage from "./v3/pages/shop/customer_profile";
import LegalPage from "./v3/pages/basic/legal";
import PaymentPage from "./v3/pages/shop/pay";
import ThankYouPage from "./v3/pages/shop/thank_order";
import LinkTreePage from "./v3/pages/linktree/link-tree";
import MainLayout from "./v3/pages/layout";
import App from "./App";
import SitemapPage from "./v3/pages/basic/site-map";
import PromoPay from "./v2/src/promo/pay";
import DevLayout from "./dev/layout";
import AppVersion3 from "./v3";
import AppVersion1 from "./v1";
import AppVersion2 from "./v2";
import BusinessCard from "./dev/business_card";
import AppVersion4 from "./v4";
import LinkTree from "./link-tree";

export const router = createBrowserRouter([

    { index: true, element: <LinkTree /> },

    // { index: true, element: <AppVersion4 /> },
    // {
    //   path: '/dev',
    //   element: <DevLayout />,
    //   errorElement: <NotFoundPage />,
    //   children: [
    //       { path: '/dev/v1', element: <AppVersion1 /> },
    //       { path: '/dev/v2', element: <AppVersion2 /> },
    //       { path: '/dev/v3', element: <AppVersion3 /> },
    //       { path: '/dev/v4', element: <AppVersion4 /> },
    //   ]
    // },
    // {
    //     path: '/shop',
    //     element: <MainLayout />,
    //     errorElement: <NotFoundPage />,
    //     children: [
    //         { index: true, element: <App /> },
    //         { path: 'catalog', element: <CatalogPage /> },
    //         { path: 'catalog/:id', element: <ProductDetailPage /> },
    //         { path: 'search', element: <SearchPage /> },
    //         { path: 'promo', element: <PromoPage /> },
    //         { path: 'cart', element: <CartPage /> },
    //         { path: 'checkout', element: <CheckoutPage /> },
    //         { path: 'track-order', element: <OrderTrackingPage /> },
    //         { path: 'blog', element: <BlogPage /> },
    //         { path: 'blog/:id', element: <BlogPostPage /> },
    //         { path: 'about', element: <AboutUsPage /> },
    //         { path: 'contacts', element: <ContactsPage /> },
    //         { path: 'delivery', element: <DeliveryPaymentPage /> },
    //         { path: 'profile', element: <UserProfilePage /> },
    //         { path: 'legal', element: <LegalPage /> },
    //     ],
    // },
    // {
    //     // 2. Окремі сторінки без загального Header/Footer
    //     path: '/payment',
    //     element: <PaymentPage />,
    // },
    // {
    //     path: '/thank-you',
    //     element: <ThankYouPage />,
    // },
    // {
    //     path: '/links', // Ваш Linktree для Instagram
    //     element: <LinkTreePage />,
    // },
    // {
    //     path: '/sitemap', // Ваш Linktree для Instagram
    //     element: <SitemapPage />,
    // },
    // {
    //     path: '/business-card',
    //     element: <BusinessCard />,
    // },
    {
        // 3. Обробка всіх неіснуючих роутів (404)
        path: '*',
        element: <NotFoundPage />,
    },

    // {
    //     //TODO: delete or use. TEST PAGE GEO LOCATION TRACK
    //     path: '/geo/:url',
    //     element: <PromoPay />,
    // },
]);